
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commissions/[slug]",
      function () {
        return require("private-next-pages/commissions/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commissions/[slug]"])
      });
    }
  